import { FormFicheOrganismeFormation } from "../../components/form/formFicheOrganismeFormation"
import { enumOrganismeFormationCategorie } from "../../enums/enumOrganismeFormationCategorie"

export const EditionFicheComposante = () => {
    return (
        <FormFicheOrganismeFormation
            organismeFormationCategorie={enumOrganismeFormationCategorie.COMPOSANTEECOLE}
        />
    )
}